module.exports = __webpack_public_path__ + "static/img/cont37_02.347ba38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_02.jpg
// module id = i3Ag
// module chunks = 0